import { EnumReducers } from 'src/types/redux/reducers';
import { EnumProductType } from 'src/types/common/product';
export const reducer = {
  [EnumProductType.Set]: EnumReducers.productSet,
  [EnumProductType.Simple]: EnumReducers.simpleProduct,
  [EnumProductType.Variant]: EnumReducers.variantProduct,
};
